module.exports = __webpack_public_path__ + "assets/assets/images/brand/footer-logo.1a8ab530.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/brand/footer-logo.svg
// module id = 272
// module chunks = 2